import React, { useState, useRef } from "react";
import { Row, Col, Form, Button, Card } from "react-bootstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios"; // Import axios for API calls

const EditableResumeTemplate = () => {
  const [jobTitle, setJobTitle] = useState('');
  const [jobDescription, setJobDescription] = useState('');

  const handleJobTitleChange = (e) => {
    setJobTitle(e.target.value);
  };

  const fetchJobDescription = async () => {
    try {
      const response = await axios.post('http://192.168.0.14:5000/api/ai/generate-job-description-suggestions', { title: jobTitle });
      if (response.data.success) {
        setJobDescription(response.data.data);
      } else {
        alert('Failed to fetch job description.');
      }
    } catch (error) {
      console.error('Error fetching job description:', error);
      alert('An error occurred while fetching the job description.');
    }
  };
  const [cvData, setResume] = useState({
    name: "Shubham Mukati",
    title: "Software Engineer",
    phoneNumber: "7247643764",
    email: "shubham.mukati@parkhya.net",
    location: "Indore, India",
    summary: "Experienced software engineer with a passion for developing innovative applications.",
    experience: [
      {
        title: "Software Developer",
        company: "Parkhya Solution Pvt. Ltd.",
        startDate: "2024-12-16",
        endDate: "till now",
        description: "Worked on building scalable web applications using React and Node.js.",
      },
    ],
    education: [
      {
        degree: "B.Tech (CSE)",
        institution: "SAGE University, Indore",
        startDate: "2019",
        endDate: "2023",
      },
    ],
    projects: [
      {
        title: "Balloon Decoration",
        description: "A Website show the Event Management & Decoration ideas and images",
        technologies: ["HTML", "CSS", "JavaScript"],
        link: "https://aaiji-decoration.com",
      },
    ],
    skills: ["JavaScript", "React", "Node.js"],
    extraFields: {
      github: "https://github.com/shubhammukati",
      linkedin: "https://linkedin.com/in/shubhammukati",
    },
  });

  const handleChange = (e, field) => {
    setResume({ ...cvData, [field]: e.target.value });
  };

  const handleNestedChange = (e, field, index, subField) => {
    const updatedField = [...cvData[field]];
    updatedField[index] = {
      ...updatedField[index],
      [subField]: e.target.value,
    };
    setResume({ ...cvData, [field]: updatedField });
  };

  const addEntry = (field, newEntry) => {
    setResume({ ...cvData, [field]: [...cvData[field], newEntry] });
  };

  const removeEntry = (field, index) => {
    const updatedField = cvData[field].filter((_, i) => i !== index);
    setResume({ ...cvData, [field]: updatedField });
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setResume({ ...cvData, photo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const componentRef = useRef();

  const handleSaveAsPDF = () => {
    const pdf = new jsPDF();

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(22);
    pdf.text(cvData.name, 20, 20);

    pdf.setFontSize(16);
    pdf.text(cvData.title, 20, 30);

    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");
    pdf.text(`Phone: ${cvData.phoneNumber}`, 20, 40);
    pdf.text(`Email: ${cvData.email}`, 20, 50);
    pdf.text(`Location: ${cvData.location}`, 20, 60);

    pdf.setFont("helvetica", "bold");
    pdf.text("Summary:", 20, 70);
    pdf.setFont("helvetica", "normal");
    pdf.text(cvData.summary, 20, 80, { maxWidth: 170 });

    let y = 90; // Dynamic Y position tracking

    const addSection = (title) => {
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.text(title, 20, y);
      y += 8;
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(12);
    };

    // Experience Section as a Table
    if (cvData.experience.length) {
      addSection("Experience:");
      pdf.autoTable({
        startY: y,
        head: [["Title", "Company", "Start Date", "End Date", "Description"]],
        body: cvData.experience.map((exp) => [
          exp.title,
          exp.company,
          exp.startDate,
          exp.endDate,
          exp.description,
        ]),
        styles: { fontSize: 10, cellWidth: "wrap" },
      });
      y = pdf.lastAutoTable.finalY + 10;
    }

    // Education Section as a Table
    if (cvData.education.length) {
      addSection("Education:");
      pdf.autoTable({
        startY: y,
        head: [["Degree", "Institution", "Start Date", "End Date"]],
        body: cvData.education.map((edu) => [
          edu.degree,
          edu.institution,
          edu.startDate,
          edu.endDate,
        ]),
        styles: { fontSize: 10 },
      });
      y = pdf.lastAutoTable.finalY + 10;
    }

    // Projects Section
    if (cvData.projects.length) {
      addSection("Projects:");
      cvData.projects.forEach((proj) => {
        pdf.text(`• ${proj.title}`, 25, y);
        y += 6;
        pdf.text(proj.description, 25, y, { maxWidth: 170 });
        y += 6;
        pdf.text(`Technologies: ${proj.technologies.join(", ")}`, 25, y);
        y += 6;
        pdf.text(`Link: ${proj.link}`, 25, y);
        y += 10;
      });
    }

    // Skills List
    if (cvData.skills.length) {
      addSection("Skills:");
      cvData.skills.forEach((skill) => {
        pdf.text(`• ${skill}`, 25, y);
        y += 8;
      });
      y += 5;
    }

    // Extra Fields Section
    if (cvData.extraFields) {
      addSection("Extra Fields:");
      pdf.text(`GitHub: ${cvData.extraFields.github}`, 25, y);
      y += 8;
      pdf.text(`LinkedIn: ${cvData.extraFields.linkedin}`, 25, y);
      y += 10;
    }

    pdf.save("cvData.pdf");
  };

  // Save draft API request
  const handleSaveDraft = async () => {
    try {
      const response = await axios.post(
        "https://ai-powered-cv-maker-api.vercel.app/api/draft/save-draft/67ab39cb0000f2df3bd0aa01",
        { cvData }, // Wrapped inside an object to match API format
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Response", response);

      if (response.status === 200) {
        alert("Draft saved successfully!");
      } else {
        alert("Failed to save draft.");
      }
    } catch (error) {
      console.error("Error saving draft:", error);
      alert(
        `An error occurred while saving the draft: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <div className="container">
      <Row>
        <Col md={6} className="">
          <Card>
            <Card.Body>
              <h4>Edit Resume</h4>

              <Form.Group className="mb-3">
                <Form.Label>Upload Photo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handlePhotoUpload}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.name}
                  onChange={(e) => handleChange(e, "name")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.title}
                  onChange={(e) => handleChange(e, "title")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Summary</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={cvData.summary}
                  onChange={(e) => handleChange(e, "summary")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.phoneNumber}
                  onChange={(e) => handleChange(e, "phoneNumber")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.email}
                  onChange={(e) => handleChange(e, "email")}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.location}
                  onChange={(e) => handleChange(e, "location")}
                />
              </Form.Group>

              {/* Experience */}
              <h5>Experience</h5>
              {cvData.experience.map((exp, index) => (
                <div key={index}>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.title}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "title")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.company}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "company")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.startDate}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "startDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.endDate}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "endDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={exp.description}
                      onChange={(e) =>
                        handleNestedChange(e, "experience", index, "description")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("experience", index)}
                  >
                    Remove
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("experience", {
                    title: "",
                    company: "",
                    startDate: "",
                    endDate: "",
                    description: "",
                  })
                }
              >
                Add Experience
              </Button>

              {/* Education */}
              <Form.Group className="mb-3">
                <Form.Label>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  value={jobTitle}
                  onChange={handleJobTitleChange}
                  placeholder="Enter job title"
                />
              </Form.Group>
              <Button onClick={fetchJobDescription} className="mb-3">
                Generate Job Description
              </Button>
              {jobDescription && (
                <div className="mb-3">
                  <h5>Generated Job Description</h5>
                  <p>{jobDescription}</p>
                </div>
              )}
              <h5>Education</h5>
              {cvData.education.map((edu, index) => (
                <div key={index}>
                  <Form.Group className="mb-3">
                    <Form.Label>Degree</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.degree}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "degree")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Institution</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.institution}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "institution")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.startDate}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "startDate")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.endDate}
                      onChange={(e) =>
                        handleNestedChange(e, "education", index, "endDate")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("education", index)}
                  >
                    Remove
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("education", {
                    degree: "",
                    institution: "",
                    startDate: "",
                    endDate: "",
                  })
                }
              >
                Add Education
              </Button>

              {/* Projects */}
              <h5>Projects</h5>
              {cvData.projects.map((proj, index) => (
                <div key={index}>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.title}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "title")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={proj.description}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "description")
                      }
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Technologies</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.technologies.join(", ")}
                      onChange={(e) => {
                        const updatedTechnologies = e.target.value.split(", ");
                        const updatedProjects = [...cvData.projects];
                        updatedProjects[index] = {
                          ...updatedProjects[index],
                          technologies: updatedTechnologies,
                        };
                        setResume({ ...cvData, projects: updatedProjects });
                      }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={proj.link}
                      onChange={(e) =>
                        handleNestedChange(e, "projects", index, "link")
                      }
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("projects", index)}
                  >
                    Remove
                  </Button>
                </div>
              ))}
              <Button
                onClick={() =>
                  addEntry("projects", {
                    title: "",
                    description: "",
                    technologies: [],
                    link: "",
                  })
                }
              >
                Add Project
              </Button>

              {/* Skills */}
              <h5>Skills</h5>
              {cvData.skills.map((skill, index) => (
                <div key={index}>
                  <Form.Group className="mb-3">
                    <Form.Label>Skill</Form.Label>
                    <Form.Control
                      type="text"
                      value={skill}
                      onChange={(e) => {
                        const updatedSkills = [...cvData.skills];
                        updatedSkills[index] = e.target.value;
                        setResume({ ...cvData, skills: updatedSkills });
                      }}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    onClick={() => removeEntry("skills", index)}
                  >
                    Remove
                  </Button>
                </div>
              ))}
              <Button onClick={() => addEntry("skills", "")}>
                Add Skill
              </Button>

              {/* Extra Fields */}
              <h5>Extra Fields</h5>
              <Form.Group className="mb-3">
                <Form.Label>GitHub</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.github}
                  onChange={(e) => {
                    const updatedExtraFields = {
                      ...cvData.extraFields,
                      github: e.target.value,
                    };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.extraFields.linkedin}
                  onChange={(e) => {
                    const updatedExtraFields = {
                      ...cvData.extraFields,
                      linkedin: e.target.value,
                    };
                    setResume({ ...cvData, extraFields: updatedExtraFields });
                  }}
                />
              </Form.Group>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <div
            ref={componentRef}
            style={{ padding: "20px", backgroundColor: "#f9f9f9" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div>
                <h2>{cvData.name}</h2>
                <h4>{cvData.title}</h4>
              </div>
              <div>
                {cvData.photo && (
                  <img
                    src={cvData.photo}
                    alt="Profile"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </div>
            </div>

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Summary
            </h5>
            <p>{cvData.summary}</p>

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Experience
            </h5>
            {cvData.experience.map((exp, index) => (
              <div key={index}>
                <h6>
                  {exp.title} at {exp.company}
                </h6>
                <p>
                  {exp.startDate} - {exp.endDate}
                </p>
                <p>{exp.description}</p>
              </div>
            ))}

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Education
            </h5>
            {cvData.education.map((edu, index) => (
              <div key={index}>
                <h6>{edu.degree}</h6>
                <p>
                  {edu.institution} | {edu.startDate} - {edu.endDate}
                </p>
              </div>
            ))}

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Projects
            </h5>
            {cvData.projects.map((proj, index) => (
              <div key={index}>
                <h6>{proj.title}</h6>
                <p>{proj.description}</p>
                <p>Technologies: {proj.technologies.join(", ")}</p>
                <p>Link: {proj.link}</p>
              </div>
            ))}

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Skills
            </h5>
            <ul>
              {cvData.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>

            <h5
              style={{
                background: "linear-gradient(to right, #1e3c72, #2a5298)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              Extra Fields
            </h5>
            <p>GitHub: {cvData.extraFields.github}</p>
            <p>LinkedIn: {cvData.extraFields.linkedin}</p>
          </div>

          <Button onClick={handleSaveAsPDF} className="mt-3 w-100">
            Save as PDF
          </Button>
          <Button
            onClick={handleSaveDraft}
            variant="primary"
            className="mt-3 w-100"
          >
            Save as Draft
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default EditableResumeTemplate;
